import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { AuthService } from '~app/modules/authorization/services/authorization-idam.service';
import { Router } from '@angular/router';
import {
  APP_USER_IDAM_REGISTER_ROUTE,
  APP_USER_PASSWORDLESS_SIGNUP_ROUTE,
  NUMBER_1,
} from '~shared/constants';
import {
  FF_ENABLE_AUTH_URL_FROM_HOME_PAGE,
} from '~app/modules/authorization/constants/validate-email.constant';
import { environment } from '~env/environment';
import { ReplaySubject } from 'rxjs';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';

import { REQUEST } from '@nguniversal/express-engine/tokens';
import { IdentityService } from '~app/core/modules/identity/services/identity.service';
import { filter, take, map } from 'rxjs/operators';
import { AccountInfoFetchingStatus, AccountType } from '~shared/models';
import { UrlUtil } from '~shared/utils/url.util';

export const MAGIC_LINK_BAG_KEY = 'magic-link-bag';


@Component({
  selector: 'app-login-redirect',
  templateUrl: './login-redirect.component.html',
  styleUrls: ['./login-redirect.component.scss'],
})
export class LoginRedirectComponent implements OnInit, OnDestroy {
  @ViewChild('form', { read: ElementRef }) formElement: ElementRef;
  checkIcon = `${environment.cdnBaseUrl()}/images/icon-small-check-filled.svg`;
  // eslint-disable-next-line no-magic-numbers
  protected unsubscribe$ = new ReplaySubject<void>(1);

  constructor( // NOSONAR
    private activeFeaturesConfigcatService: ActiveFeaturesConfigcatService,
    private identityService: IdentityService,
  ) {
  }
  ngOnInit(): void {
    this.identityService.getAuthAccountInfoStatus().pipe(
      filter((accountInfoFetchingStatus) => accountInfoFetchingStatus !== AccountInfoFetchingStatus.LOADING),
      take(NUMBER_1),
      map((accountInfoFetchingStatus) =>
        [AccountType.EMPLOYEE_AS_CUSTOMER].includes(accountInfoFetchingStatus as AccountType)
      )
    ).subscribe((isEmployeeAsCustomer) => {
      if (isEmployeeAsCustomer) {
        UrlUtil.redirectToReactHomePage();
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
